import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IStudentProfilesListing {
  url?: string;
  text?: string;
  enabled: boolean;
}

export type StudentProfilesListingModel = Model<IStudentProfilesListing>;

angular.module('capability-ng-academic-planner').factory(
  'ngStudentProfilesListingModel',
  () =>
    new Model<IStudentProfilesListing>({
      url: undefined,
      text: undefined,
      enabled: false /* default this functionality is disabled, 
    we expect this button to be shown only when ap is loaded inside a container not part of SPD */
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/student_profiles_listing/models/student_profiles_listing_model.ts